<template>
  <ProsCollection :recommendation-config="recommendationConfig" :panel-config="panelConfig" />
</template>

<script setup>
import { computed } from 'vue';
import ProsCollection from '@nuxt-common/pros-collection/app/components/ProsCollection.vue';

// Pinia Store & Composables
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';

const props = defineProps({
  items: {
    type: Array,
    default() {
      return [];
    },
  },
  dataContext: {
    type: String,
    default: '',
  },
  killswitches: {
    type: Object,
    default() {
      return {};
    },
  },
  dataMaxRecs: {
    type: String,
    default() {
      return '30';
    },
  },
  alignHorizontal: {
    type: Boolean,
    default() {
      return false;
    },
  },
});
const envPropsStore = useEnvPropsStore();

// Computed properties
const productIds = computed(() => props.items.map((item) => item.productId));
const productId = computed(() => {
  const list = props.items;
  return list.length > 0 ? list[list.length - 1].productId : '-9';
});
const panelConfig = computed(() => ({
  componentType: props.alignHorizontal || envPropsStore.envProps?.isMew ? ' ProsCarousel' : 'ProsVertical',
  properties: {
    ...props.killswitches,
    prosZonesAddToListEnabled: true,
    prosZoneCSGRedesignScalingEnabled: true,
  },
}));
const recommendationConfig = computed(() => ({
  zone: props.dataContext,
  productId: productId.value,
  productIds: productIds.value,
  maxRecommendations: props.dataMaxRecs,
}));
</script>
